module.exports = __webpack_public_path__ + "static/media/audio.b9c5294e.svg";